import React, { useEffect, useRef, useState } from 'react';
import cx from 'classnames';
import {
  CheckRoundedIcon,
  FilterNoneRoundedIcon,
  IconButton,
} from '@unisporkal/alliance-ui';

import styles from './CopyButton.module.scss';

type Timer = ReturnType<typeof setTimeout>;

// TODO(CU-86bbzx4p3): duplicated from collaboration's CopyButton; delete once
// a shared version lands in @unisporkal/alliance-ui.
export interface CopyButtonProps {
  value: string;
  ariaLabel: string;
  copiedAriaLabel?: string;
  className?: string;
  iconSize?: number;
  resetDelayMs?: number;
  'data-testid'?: string;
}

const CopyButton = ({
  value,
  ariaLabel,
  copiedAriaLabel,
  className,
  iconSize = 16,
  resetDelayMs = 2000,
  'data-testid': testId = 'copy-button',
}: CopyButtonProps): React.ReactElement => {
  const [copied, setCopied] = useState(false);
  const resetTimer = useRef<Timer | undefined>(undefined);

  useEffect(
    () => () => {
      if (!resetTimer.current) return;
      clearTimeout(resetTimer.current);
    },
    []
  );

  const handleClick = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      return;
    }

    setCopied(true);
    clearTimeout(resetTimer.current);
    resetTimer.current = setTimeout(() => setCopied(false), resetDelayMs);
  };

  return (
    <IconButton
      ariaLabel={copied && copiedAriaLabel ? copiedAriaLabel : ariaLabel}
      className={cx(styles.copyButton, className)}
      onClick={handleClick}
      data-testid={testId}
    >
      {copied ? (
        <CheckRoundedIcon
          size={iconSize}
          data-testid={`${testId}-copied-icon`}
        />
      ) : (
        <FilterNoneRoundedIcon
          size={iconSize}
          data-testid={`${testId}-copy-icon`}
        />
      )}
    </IconButton>
  );
};

CopyButton.displayName = 'CopyButton';

export default CopyButton;
